import Model, { Integer, MODEL_LEVEL } from 'src/models/model'

// See local constants.js file for Permission enums. Model.js must import from it directly to avoid circular dependencies.
export default class Permission extends Model {
  static name = 'Permission'

  static deletable = false

  static versioned = false

  static paginate = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Security]

  static define () {
    this.fields = {
      action: {
        type: String,
        sortable: true,
        output: true
      },
      category: {
        type: String,
        output: true
      },
      label: {
        type: String,
        sortable: true,
        output: true
      },
      description: {
        type: String,
        output: true,
        default: null
      },
      dependsOnPermission: {
        type: String,
        output: true,
        default: null
      },
      displayOrder: {
        type: Integer,
        default: 100,
        output: true
      },
      permitsEmployeeUsers: {
        type: Boolean,
        default: false,
        output: true
      }
    }
  }

  /**
   * For now we assume permissions will at most require Admin access level.
   * Some permissions may not permit users with just Employee access level.
   */
  get permitsAdminUsers () {
    return true
  }
}
